<div id="wrapper" class="wrapper clearfix">
    <app-header></app-header>
    <section id="hedging" class="bg-white">
        <div class="container">
            <div class="row">
                <div class="d-flex align-items-start">
                    <div class="col-sm-12 ">
                        <div style="text-align: center; " i18n="@@notFound">Aradığınız sayfa bulunamadı!</div>
                    </div>                   
                </div>
            </div>
        </div>
    </section>
    <app-footer></app-footer>
    <div id="back-to-top" class="backtop"><fa-icon [icon]="faArrUp"></fa-icon></div>
</div>